import { useState, useEffect } from "react";
import { getLive } from "../../network/lib/siteSetting";
import headerLogo from "../../assests/images/header/logo.jpg";
import banner from "../../assests/images/header/banner.png";

export default function Header() {
  const [logo, SetLogo] = useState();

  useEffect(() => {
    !logo &&
      getLive().then(
        (res) =>
          res.status == 200 &&
          res.data.length > 0 &&
          SetLogo(res.data[0].bannerImage)
      );
  }, []);

  return (
    <div className="div-topbanner">
      <div
        className="Table"
        style={{
          margin: "0px auto",
          minWidth: "100%",
          height: "100%",
          padding: "0px",
        }}
      >
        <div className="Row" style={{ display: "flex" }}>
          <div className="Cell" style={{ padding: "0px", display: "inline" }}>
            <img
              id="imgProfileLogo"
              src={!logo ? headerLogo : logo}
              border="0"
              alt="Header Logo"
              style={{ float: "left", width: "100%" }}
            />
          </div>
          <div className="Cell" style={{ padding: "0px", display: "inline" }}>
            <img
              id="banner"
              src={banner}
              border="0"
              alt="Header Banner"
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
